<script>
import * as moment from 'moment';

export default {
  data: function () {
    let numDaysInPast = 5; // Duplicate in Sales module

    return {
      averageEggProduction: {},

      fromDate: moment().add(-numDaysInPast, 'days').format('YYYY-MM-DD'),
      toDate: moment().format('YYYY-MM-DD'),
    };
  },
}
</script>

<template>
  <b-card>

    <div class="h3 m-0 text-center"> Production </div>

    <api-loader
      :key="`${encodeURIComponent(fromDate)}/${encodeURIComponent(toDate)}`"
      method="get"
      :url="`v1/layeradmin/average-egg-production/${encodeURIComponent(fromDate)}/${encodeURIComponent(toDate)}`"
      @loaded="averageEggProduction=$event">

      <div slot-scope="{busy}" class="mt-3">
        <div class="text-center"> <label class="font-weight-bold">Date Range</label> </div>
        <div class="row">
          <div class="col-6">
            <b-form-input :id="`from-${_uid}`" v-model="fromDate" type="date" size="sm" :disabled="busy"></b-form-input>
          </div>
          <div class="col-6">
            <b-form-input :id="`to-${_uid}`" v-model="toDate" type="date" size="sm" :disabled="busy"></b-form-input>
          </div>
        </div>

        <div class="mt-5"></div>

        <table class="table table-bordered table-sm">
          <thead>
            <th>Size</th>
            <th>Average eggs</th>
          </thead>

          <tr v-for="(num, size) in averageEggProduction" :key="size">
            <td> {{size}} </td>
            <td> {{num}} </td>
          </tr>

          <tr v-if="!busy&&Object.keys(averageEggProduction||{}).length===0">
            <td colspan="20" class="text-warning">No production records. Please check the Packing Records between {{fromDate}} and {{toDate}} </td>
          </tr>
        </table>
      </div>

    </api-loader>

  </b-card>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/components/AverageEggProduction.vue